import { ReactNode, memo } from 'react';

import { MoreVert } from 'icons';
import { twMerge } from 'tailwind-merge';

import { useRandomColor } from '../../hooks';
import { DropdownMenuButton } from '../../molecules';
import { ListItem } from '../../templates';

interface ListItemWithStatusProps {
  name: string;
  nameClassName?: string;
  icon?: ReactNode;
  rightElement?: ReactNode;
  status?: ReactNode;
  dropdownMenu?: ReactNode;
  className?: string;
  onClick?: () => void;
  iconClassName?: string;
  hasAutoPadding?: boolean;
  rightSideContentClassName?: string;
}

function ListItemWithIconBase({
  name,
  nameClassName,
  icon,
  rightElement,
  status,
  dropdownMenu,
  onClick,
  className,
  iconClassName,
  hasAutoPadding,
  rightSideContentClassName,
}: ListItemWithStatusProps) {
  const { bg } = useRandomColor(name);
  return (
    <ListItem
      className={twMerge(`flex justify-between items-center w-full`, className)}
      onClick={onClick}
      hasAutoPadding={hasAutoPadding}
    >
      <div className="flex items-center space-x-4">
        <div
          className={twMerge(
            'w-8 h-8 rounded-10 text-white font-semibold text-lg flex justify-center items-center overflow-hidden',
            bg,
            iconClassName,
          )}
        >
          {icon ? icon : name.charAt(0)}
        </div>
        <div className="space-y-1">
          <div
            className={twMerge(
              'text-sm font-medium text-v2blueGray-800 leading-[17px]',
              nameClassName,
            )}
          >
            {name}
          </div>
          {status ? status : null}
        </div>
      </div>
      <div className={twMerge('flex', rightSideContentClassName)}>
        {dropdownMenu ? (
          <DropdownMenuButton
            classNamePopup="max-h-[80vh] overflow-y-auto"
            className="z-0"
            position="bottom-end"
            label={
              <div className="w-9 h-9 flex justify-center items-center text-v2blueGray-800">
                <MoreVert className="w-6 h-6" />
              </div>
            }
          >
            {dropdownMenu}
          </DropdownMenuButton>
        ) : null}

        {rightElement && <div className="flex items-center">{rightElement}</div>}
      </div>
    </ListItem>
  );
}

export const ListItemWithIcon = memo(ListItemWithIconBase);
